import routerOptions0 from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/node_modules/.pnpm/nuxt@3.19.3_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler_37e8c2ab4e677a5a11de1ffa5820ba05/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}